import React, { useEffect, useState } from "react";
import PropTypes from "prop-types";
import clsx from "clsx";
import { Formik } from "formik";
import {
  Button,
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  makeStyles,
  Typography,
  Divider,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
} from "@material-ui/core";
import Autocomplete from '@material-ui/lab/Autocomplete';

import { SIREN_CONFIG } from "config.js";
import { getRoomTypes, getRoomTypeLabel, getRoomTypeRow } from 'utils/RoomType';
// import { loadCaregiverList, getCaregiverValue, getCaregiverTelNo } from "utils/LoadConfiguration";
import {useSelector} from 'react-redux';
import { FormattedMessage, useIntl } from "react-intl";


const RoomUpdateForm = (props) => {
  const { className, history, roomInfo, ...rest } = props;
  const classes = useStyles();
  const {formatMessage} = useIntl();

  const [roomTypes, setRoomTypes] = useState([]);
  const [selectedRoomType, setSelectedRoomType] = useState('');

  // const [patientList, setPatientList] = useState([]);
  const [deviceList, setDeviceList] = useState([]);

  const [caregiverList, setCaregiverList] = useState([]);
	// const [selectedCaregiver1_Id, setSelectedCaregiver1_Id] = useState('');
  // const [selectedCaregiver2_Id, setSelectedCaregiver2_Id] = useState('');
  const facility_id = useSelector((store) => store.user.facility_id);

  const handleSubmit = (event, values) => {
    event.preventDefault();

    fetch(`${SIREN_CONFIG.HOSTNAME}/room/updateRoom`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        facility_id: facility_id,
        roomId: values.roomId,
        roomName: values.roomName,
        roomType: selectedRoomType,
        // caregiver1_id: selectedCaregiver1_Id,
        // caregiver2_id: selectedCaregiver2_Id,
      }),
    })
      .then((response) => {
        return response.json();
      })
      .then((responseData) => {
        if (responseData.resultCode === "000") {
          alert(formatMessage({id:'update_successful'}));

          setTimeout(() => {
            history.goBack();
          }, 500);
        } else {
          //에러
          console.log(responseData.message);
          alert(`${formatMessage({id:'update_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
        }
      })
      .catch((error) => {
        console.error(error);
        alert(`${formatMessage({id:'update_failed'})}\n${responseData.message}`);
      });
  };

  const handleDelete = () => {

    fetch(`${SIREN_CONFIG.HOSTNAME}/room/deleteRoom`, {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({
        facility_id: facility_id,
        roomId: roomInfo.roomId,
      }),
    }).then((response) => {
        return response.json();
		}).then((responseData) => {
			if (responseData.resultCode === "000") {
        alert(formatMessage({id:'delete_successful'}));

				setTimeout(() => {
					history.goBack();
				}, 500);
			} else {
				//에러
        console.log(responseData.message);
        alert(`${formatMessage({id:'delete_failed'})}\n${responseData.resultMessage}\n${responseData.message}`);
			}
		}).catch((error) => {
        console.error(error);
        alert(`${formatMessage({id:'delete_failed'})}\n${responseData.message}`);
		});
  }


  /**
   * 룸을 담당하는 요양사 리스트 얻기
   * @param {*} roomId 
   */
  const loadCaregiverList = (roomId) => {

    fetch(`${SIREN_CONFIG.HOSTNAME}/caregiver/caregiverListWithinRoom?facility_id=${facility_id}&roomId=${roomId}`)
    .then(res => res.json())
    .then(snapshot => {
      var list = [];
      if(snapshot.resultData != null){
        snapshot.resultData.forEach( doc => {
          list.push(doc);
        });
      }

      setCaregiverList(list);
    });
  }

  // const loadPatientList = (roomId) => {

  //   fetch(`${SIREN_CONFIG.HOSTNAME}/patient/patientList?facility_id=${facility_id}&roomId=${roomId}`)
  //   .then(res => res.json())
  //   .then(snapshot => {
  //     var list = [];
  //     if(snapshot.resultData != null){
  //       snapshot.resultData.forEach( doc => {
  //         list.push(doc);
  //       });
  //     }

  //     setPatientList(list);
  //   });
  // }


  /**
   * 룸에 할당된 센서 리스트
   * @param {*} roomId 
   */
  const loadDevicelist = (roomId) => {

    fetch(`${SIREN_CONFIG.HOSTNAME}/device/deviceList?facility_id=${facility_id}&roomId=${roomId}`)
    .then(res => res.json())
    .then(snapshot => {
      var list  = [];
      if( snapshot.resultData != null){
        snapshot.resultData.forEach( doc => {
          list.push(doc);
        });
      }
      setDeviceList( list );
    });
  }


	const cancelConfirm = () => console.log("delete cancled.");

	const useConfirm = (msg = "", onConfirm, onCancel) => {
		if (!onConfirm || typeof onConfirm !== "function") return;
		if (!onCancel || typeof onCancel !== "function") return;

		const doDelete = () => {
			if(window.confirm(msg)){
				onConfirm();
			} else {
				onCancel();
			}
		}

		return doDelete;
	};


	const confirmDelete = useConfirm( formatMessage({id:'question_delete'}) ,
		handleDelete,
		cancelConfirm);


  const handleBack = () => {
    history.goBack();
  };


  useEffect(() => {
		// setSelectedCaregiver1_Id(roomInfo.caregiver1_id);
    // setSelectedCaregiver2_Id(roomInfo.caregiver2_id);

    // async function loadCaregiverInfo(){
    //   setCaregiverList( await loadCaregiverList(facility_id ) );
    // }
    // loadCaregiverInfo();

    loadCaregiverList(roomInfo.roomId);
    // loadPatientList(roomInfo.roomId);
    loadDevicelist(roomInfo.roomId);

    setSelectedRoomType(roomInfo.roomType);
    setRoomTypes(getRoomTypes());

  }, []);



  return (
    <Formik
      initialValues={{
        roomId: roomInfo.roomId || "",
        roomName: roomInfo.roomName || "",
        roomType: selectedRoomType || "",
        // caregiver1_id: selectedCaregiver1_Id || "",
        // caregiver2_id: selectedCaregiver2_Id || "",
      }}
    >
      {({
        errors,
        handleBlur,
        handleChange,
        isSubmitting,
        touched,
        values,
      }) => {
          return (
            <form
              className={clsx(classes.root, className)}
              onSubmit={(e) => handleSubmit(e, values)}
            >
              <Card>
                <CardHeader
                  className={classes.card_header}
                  title={formatMessage({id:'room_info'})}
                  titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h4' }} />

                <CardContent>
                  <Grid container spacing={2}>
                    <Grid item md={4} xs={12}>
                      <TextField
                        error={Boolean(touched.roomId && errors.roomId)}
                        fullWidth
                        helperText={touched.roomId && errors.roomId}
                        label={formatMessage({id:'room_id'})}
                        name="roomId"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        required
                        value={values.roomId}
                        variant="outlined"
                        inputProps={{ maxLength: 26 }}
                        disabled />
                    </Grid>


                    <Grid item md={4} xs={12}>
                      <TextField
                        error={Boolean(touched.roomName && errors.roomName)}
                        fullWidth
                        helperText={touched.roomName && errors.roomName}
                        label={formatMessage({id:'room_name_label'})}
                        name="roomName"
                        onBlur={handleBlur}
                        onChange={handleChange}
                        required
                        value={values.roomName}
                        variant="outlined"
                        inputProps={{ maxLength: 24 }} />
                    </Grid>


                    <Grid item md={4} xs={12}>
                      <Autocomplete
                        id="roomType"
                        // style={{ width: 300 }}
                        options={roomTypes}
                        autoHighlight
                        getOptionLabel={(option) => (option.roomTypeLabel ? option.roomTypeLabel : "")}
                        getOptionSelected={(option, value) => option.roomTypeLabel === value.roomTypeLabel}
                        value={getRoomTypeRow(selectedRoomType)}

                        renderInput={(params) => (
                          <TextField
                            {...params}
                            label={formatMessage({id:'select_room_type'})}
                            variant="outlined"
                            fullWidth
                            inputProps={{
                              ...params.inputProps,
                              autoComplete: 'new-password'
                            }} />
                        )}

                        onChange={(event, newValue) => {
                          if (newValue && newValue.roomTypeCode) {
                            setSelectedRoomType(newValue.roomTypeCode);
                            console.log(newValue);
                          }
                        } } />
                    </Grid>

                  </Grid>

                  <Grid container className={classes.action}>
                    <Grid item md={8} xs={12}>
                      <Button
                        variant="contained"
                        color="primary"
                        type="submit"
                        size="large"
                        disabled={isSubmitting}
                        className={classes.action}
                      >
                        <FormattedMessage id="update" />
                      </Button>

                      <Button
                        variant="outlined"
                        size="large"
                        onClick={handleBack}
                        className={classes.action}
                      >
                        <FormattedMessage id="cancel" />
                      </Button>

                    </Grid>

                    <Grid item align="right" md={4} xs={12}>
                      <Button
                        variant="contained"
                        color="secondary"
                        size="large"
                        className={classes.action}
                        onClick={confirmDelete}
                      >
                        <FormattedMessage id="delete" />
                      </Button>
                    </Grid>
                  </Grid>
                </CardContent>


                <Divider />

                <CardContent>
                  <CardHeader
                    className={classes.card_sub_header}
                    title={formatMessage({id:'caregiver_list'})}
                    titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h5' }} />

                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell width="10%" align="center"><FormattedMessage id="caregiver_id" /></TableCell>
                        <TableCell width="20%" align="center"><FormattedMessage id="caregiver_name" /></TableCell>
                        <TableCell width="20%" align="center"><FormattedMessage id="caregiver_tel" /></TableCell>
                        <TableCell width="30%" align="center"><FormattedMessage id="caregiver_alarm_recv_time" /></TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {caregiverList.map(module => (

                        <TableRow
                          className={classes.tableRow}
                          key={module.caregiverId}
                        >

                          <TableCell width="10%" align="center"><Typography variant="body1">{module.caregiverId}</Typography></TableCell>
                          <TableCell width="20%" align="center">{module.caregiverName}</TableCell>
                          <TableCell width="20%" align="center">{module.caregiverTelNo}</TableCell>
                          <TableCell width="30%" align="center">{module.alarmStartTime} ~{module.alarmEndTime}
                          </TableCell>
                        </TableRow>
                      ))}

                    </TableBody>
                  </Table>
                </CardContent>

                {/* <CardContent>
              <CardHeader
                className={classes.card_sub_header}
                title="환자 목록"
                titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h5' }} />

              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell width="10%" align="center">환자 이름</TableCell>
                    <TableCell width="10%" align="center">병실</TableCell>
                    <TableCell width="10%" align="center">전화번호</TableCell>
                    <TableCell width="30%" align="center">주소</TableCell>
                    <TableCell width="10%" align="center">담당 요양사</TableCell>
                    <TableCell width="10%" align="center">담당 전화번호</TableCell>
                    <TableCell width="10%" align="center">보호자 이름</TableCell>
                    <TableCell width="10%" align="center">보호자 전화번호</TableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {patientList.map(module => (

                    <TableRow
                      className={classes.tableRow}
                      key={module.id}
                    >

                      <TableCell width="10%" align="center"><Typography variant="body1">{module.patientName}</Typography></TableCell>
                      <TableCell width="10%" align="center">{module.roomName}</TableCell>
                      <TableCell width="10%" align="center">{module.patientTelNo}</TableCell>
                      <TableCell width="30%" align="center">
                        <Typography variant="body2">{module.patientAddr1} {module.patientAddr2}</Typography>
                      </TableCell>
                      <TableCell width="10%" align="center">{module.caregiverName}</TableCell>
                      <TableCell width="10%" align="center">{module.caregiverTelNo}</TableCell>
                      <TableCell width="10%" align="center">{module.protector1_name}</TableCell>
                      <TableCell width="10%" align="center">{module.protector1_tel_no}</TableCell>

                    </TableRow>
                  ))}

                </TableBody>
              </Table>
            </CardContent> */}


                <CardContent>
                  <CardHeader
                    className={classes.card_sub_header}
                    title={formatMessage({id:'sensor_list'})}
                    titleTypographyProps={{ align: "center", color: 'inherit', variant: 'h5' }} />

                  <Table>
                    <TableHead>
                      <TableRow>
                        <TableCell width="20%" align="center"><FormattedMessage id="device_sensor_id" /></TableCell>
                        <TableCell width="10%" align="center"><FormattedMessage id="room_name" /></TableCell>
                        <TableCell width="10%" align="center"><FormattedMessage id="room_position" /></TableCell>
                        <TableCell width="10%" align="center"><FormattedMessage id="room_type" /></TableCell>
                        <TableCell width="10%" align="center">silent</TableCell>
                        <TableCell width="40%" align="center"><FormattedMessage id="memo" /></TableCell>
                      </TableRow>
                    </TableHead>

                    <TableBody>
                      {deviceList.map(module => (

                        <TableRow
                          className={classes.tableRow}
                          key={module.deviceId}
                        >
                          <TableCell width="20%"><Typography variant="body1">{module.deviceId}</Typography></TableCell>
                          <TableCell width="10%">{module.roomName}</TableCell>
                          <TableCell width="10%">{module.installed_pos_detail}</TableCell>
                          <TableCell width="10%">{getRoomTypeLabel(module.roomType)}</TableCell>
                          <TableCell width="10%">{module.silentMode == 1 ? 'Y' : 'N'}</TableCell>
                          <TableCell width="40%">{module.memo}</TableCell>
                        </TableRow>
                      ))}

                    </TableBody>
                  </Table>
                </CardContent>

              </Card>
            </form>
          );
        }}
    </Formik>
  );
};

RoomUpdateForm.propTypes = {
  className: PropTypes.string,
  history: PropTypes.object,
};


export default RoomUpdateForm;


const useStyles = makeStyles((theme) => ({
  root: {
    padding: theme.spacing(2),
  },
  content: {
    marginTop: theme.spacing(2),
  },
  action: {
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    "& + &": {
      marginLeft: theme.spacing(1),
    },
  },
  card_header: {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.primary.main,
  },
  card_sub_header : {
    color: theme.palette.primary.contrastText,
    backgroundColor: theme.palette.grey.main,

    marginTop: theme.spacing(2),
  },
}));
